import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { PersistenceScope } from './persistence-scope';
import { StateVar } from './state-var';
import * as fromGraphQl from './graphql';
import { SettingsService } from '../../shared/services/settings/settings.service';

@Injectable()
export class StateService {
  protected statVal: string;
  constructor(
    private apollo: Apollo,
    private settingsService: SettingsService
  ) {}

  updateValue(key: string, stateVar: StateVar<any>, newValue: any) {
    stateVar.currentValue = newValue;

    if (stateVar.persistenceScope == PersistenceScope.LocalStorage) {
      this.setLocalStorage(key + '.' + stateVar.key, newValue);
    }
    if (stateVar.persistenceScope == PersistenceScope.SessionStorage) {
      this.setSessionStorage(key + '.' + stateVar.key, newValue);
    }
    if (stateVar.persistenceScope == PersistenceScope.Backend) {
      this.setBackendStorage(key + '.' + stateVar.key, newValue);
    }
  }

  getValue(key: string, stateVar: StateVar<any>) {
    // before we search in the different persistent repositories,
    // we assign the initial value here
    // + varaiable is typed (at least in the context)
    // + initial value is set if we do not find a value in the
    // repositories
    let value = stateVar.initialValue;
    // we know need to find the value for this property
    if (stateVar.persistenceScope == PersistenceScope.LocalStorage) {
      value = this.getLocalStorage(key + '.' + stateVar.key);
    }
    if (stateVar.persistenceScope == PersistenceScope.SessionStorage) {
      value = this.getSessionStorage(key + '.' + stateVar.key);
    }

    stateVar.currentValue = value? value : stateVar.initialValue;
    return stateVar.currentValue;
  }

  updateKeys(key: string, stateVars: Array<StateVar<any>>) {
    let sessionKeys = Object.keys(sessionStorage);
    let localKeys = Object.keys(localStorage);
    let newSessionKeys: string[] = [];
    let newLocalKeys: string[] = [];
    let newBackEndKeys: string[] = [];
    for (let stateVar of stateVars) {
      if (stateVar.persistenceScope == PersistenceScope.SessionStorage) {
        newSessionKeys.push(key + '.' + stateVar.key);
      }
      if (stateVar.persistenceScope == PersistenceScope.LocalStorage) {
        newLocalKeys.push(key + '.' + stateVar.key);
      }
      if (stateVar.persistenceScope == PersistenceScope.Backend) {
        newBackEndKeys.push(key + '.' + stateVar.key);
      }
    }
    this.updateBackEndKeys(key, newBackEndKeys);
    sessionKeys.forEach((sessionKey) => {
      if (sessionKey.includes(key)) {
        if (!newSessionKeys.includes(sessionKey)) {
          sessionStorage.removeItem(sessionKey);
        }
      }
    });
    localKeys.forEach((localKey) => {
      if (localKey.includes(key)) {
        if (!newLocalKeys.includes(localKey)) {
          localStorage.removeItem(localKey);
        }
      }
    });
  }

  private getSessionStorage(key: string) {
    let newState = sessionStorage.getItem(key);
    return newState;
  }

  private async updateBackEndKeys(key: string, newKeys: string[]) {
    let data = await this.apollo
      .query<fromGraphQl.UserSettingsQueryResponse>({
        query: fromGraphQl.USER_SETTINGS_QUERY,
      })
      .toPromise();
    let response, userSettings;
    if (data?.data?.currentUserSettings?.frontend_web) {
      response = JSON.parse(data.data.currentUserSettings?.frontend_web);
      for (let res in response) {
        if (res.includes(key)) {
          if (!newKeys.includes(res)) {
            delete response[res];
          }
        }
      }
      userSettings = {
        frontend_web: JSON.stringify(response),
      };
    } else if (newKeys.length > 0) {
      userSettings = {
        frontend_web: JSON.stringify({}),
      };
    }
    this.settingsService.updateUserSettings(
      userSettings,
      this.returnCallback()
    );
  }

  private getLocalStorage(key: string) {
    let newState = localStorage.getItem(key);
    return newState;
  }

  private setLocalStorage(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  private setSessionStorage(key: string, value: string) {
    sessionStorage.setItem(key, value);
  }

  private async setBackendStorage(key: string, state: any) {
    let data = await this.apollo
      .query<fromGraphQl.UserSettingsQueryResponse>({
        query: fromGraphQl.USER_SETTINGS_QUERY,
      })
      .toPromise();
    const response = JSON.parse(data.data?.currentUserSettings?.frontend_web);
    if (response) {
      response[key] = state;
      const userSettings = {
        frontend_web: JSON.stringify(response),
      };
      this.settingsService.updateUserSettings(
        userSettings,
        this.returnCallback()
      );
    }
  }

  private returnCallback(): any {
    // console.log('updated DB');
  }
}
